import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { stringToBoolean } from '../../../utilities/conversionUtility';
import SwatchButtonGroupList from './SwatchButtonGroupList';

function SwatchButtonGroups({
  isDisabled,
  defaultOptions,
  durations,
  options,
  setting,
  styles,
  onActiveCallback,
}) {
  const disabledOptionName = stringToBoolean(setting.hide_choosing_duration)
    && durations
    && !!durations.option_durations.length
    && durations.option;

  const colorStyles = useMemo(() => ({
    activeBackgroundColor: styles.optionsStyle.backgroundColor,
    activeColor: styles.optionsStyle.color,
    inactiveBackgroundColor: styles.optionsStyle.inactive.backgroundColor,
    inactiveColor: styles.optionsStyle.inactive.color,
  }), [
    styles.optionsStyle.backgroundColor,
    styles.optionsStyle.color,
    styles.optionsStyle.inactive.backgroundColor,
    styles.optionsStyle.inactive.color,
  ]);

  return (
    <SwatchButtonGroupList
      options={options}
      selectedDefault={defaultOptions}
      isDisabled={isDisabled}
      disabledOptionName={disabledOptionName}
      styles={colorStyles}
      onActiveCallback={onActiveCallback}
    />
  );
}

export default SwatchButtonGroups;

SwatchButtonGroups.propTypes = {
  options: PropTypes.arrayOf(Object),
  styles: PropTypes.any,
  defaultOptions: PropTypes.arrayOf(String),
};
